(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-time"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-time-component')) {
    class DeliveryTimeComponent extends HTMLElement {
      connectedCallback() {
        this.modeInputs = this.querySelectorAll('[data-delivery-mode]');
        this.schedule = this.querySelector('[data-delivery-schedule]');
        this.dateInput = this.querySelector('[data-delivery-date]');
        this.timeSelect = this.querySelector('[data-delivery-time]');
        if (!this.modeInputs.length || !this.schedule || !this.dateInput) return;

        this.setDateLimits();

        this.modeInputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.toggleSchedule();
            this.save();
          });
        });
        this.dateInput.addEventListener('change', () => {
          this.dateInput.classList.remove('--error');
          this.save();
        });
        if (this.timeSelect) {
          this.timeSelect.addEventListener('change', () => this.save());
        }

        // Block checkout if "Scheduled" is selected but no date chosen
        this.checkoutGuard = (event) => {
          const form = event.target;
          if (!(form instanceof HTMLFormElement)) return;
          if (!form.action || !form.action.includes('/cart')) return;
          if (this.getMode() === 'Scheduled' && !this.dateInput.value) {
            event.preventDefault();
            event.stopPropagation();
            this.dateInput.classList.add('--error');
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.dateInput.focus({ preventScroll: true });
          }
        };
        document.addEventListener('submit', this.checkoutGuard, true);
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.checkoutGuard, true);
      }

      getMode() {
        const checked = this.querySelector('[data-delivery-mode]:checked');
        return checked ? checked.value : 'As soon as possible';
      }

      toggleSchedule() {
        this.schedule.hidden = this.getMode() !== 'Scheduled';
      }

      setDateLimits() {
        const lead = parseInt(this.schedule.dataset.leadDays, 10) || 0;
        const max = parseInt(this.schedule.dataset.maxDays, 10) || 60;
        const fmt = (d) => d.toISOString().split('T')[0];
        const min = new Date();
        min.setDate(min.getDate() + lead);
        const limit = new Date();
        limit.setDate(limit.getDate() + max);
        this.dateInput.min = fmt(min);
        this.dateInput.max = fmt(limit);
      }

      save() {
        const scheduled = this.getMode() === 'Scheduled';
        const attributes = {
          'Delivery': scheduled ? 'Scheduled' : 'As soon as possible',
          'Delivery date': scheduled ? this.dateInput.value : '',
          'Delivery time': scheduled && this.timeSelect ? this.timeSelect.value : ''
        };
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes })
        }).catch(() => {});
      }
    }
    customElements.define('delivery-time-component', DeliveryTimeComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gift-option"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-option-component')) {
    class GiftOptionComponent extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('[data-gift-checkbox]');
        this.phoneWrapper = this.querySelector('[data-gift-phone]');
        this.phoneInput = this.querySelector('[data-gift-phone-input]');
        if (!this.checkbox || !this.phoneWrapper || !this.phoneInput) return;

        this.checkbox.addEventListener('change', () => this.sync());
        this.sync();
      }

      sync() {
        const on = this.checkbox.checked;
        this.phoneWrapper.hidden = !on;
        // Disabled inputs are never submitted, so the property only reaches
        // the order when the gift option is actually checked.
        this.phoneInput.disabled = !on;
        this.phoneInput.required = on && this.phoneInput.dataset.required === 'true';
        if (!on) this.phoneInput.value = '';
        if (on) this.phoneInput.focus({ preventScroll: true });
      }
    }
    customElements.define('gift-option-component', GiftOptionComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
